import React, { useState } from 'react';
import { useForm } from '@mantine/form';
import { Button, Group, Title, FileInput } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import {  uploadTenantUsers } from '../../services/api.service';
import { IconCheck } from '@tabler/icons-react';

const UploadUsersForm = ({ closeModal }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const form = useForm({
		initialValues: {
			file: null,
		},
	});

	// Submit form
	const onSubmit = (values) => {

		// Set loader
		toggleLoading(true);

		// Call API
		uploadTenantUsers(values, function () {

			// Show success
			notifications.show({
				title: 'Usuarios cargados correctamente',
				color: 'green',
				icon: <IconCheck />
			});

			// Close after 1 second
			setTimeout(() => {

				// Close modal
				closeModal();

			}, 1000);

		}, function (error) {

			// Remove preloader
			toggleLoading(false);

			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});

		});

	}

	return (
		<>
			{/* Form */}
			<form onSubmit={form.onSubmit(onSubmit)}>
				{/* Title */}
				<Title
					order={5}
					mb="md"
				>
					Cargar Usuarios Masivamente
				</Title>
				{/* Input Group */}
				<Group grow>
					{/* File */}
					<FileInput
						withAsterisk
						label="Archivo CSV"
						placeholder="Elige el archivo CSV con la información de los usuarios"
						value={form.values.file}
						onChange={(event) => form.setFieldValue('file', event.currentTarget.value)}
						{...form.getInputProps('file')}
					/>
				</Group>
				{/* Buttons */}
				<Group
					position="apart"
					grow
				>
					{/* Cancel */}
					<Button
						mt="xl"
						color="red"
						onClick={closeModal}
						disabled={isLoading}
						variant="light"
						sx={{ flexGrow: 1 }}
					>
						Cancelar
					</Button>
					{/* Submit */}
					<Button
						mt="xl"
						type="submit"
						loading={isLoading}
						variant="filled"
						sx={{ flexGrow: 1 }}
					>
						Cargar Usuarios
					</Button>
				</Group>
			</form>
		</>
	);

}

export default UploadUsersForm;
